<template>
    <a-modal
      title="饭卡详情"
      :visible="showModal"
      @ok="clickOk"
      @cancel="clickOk"
      :footer="null"
      class="customermodel"
      width="400px"
      :centered="true"
    >
    <div class="cardinfo-model">
      <div class="row">
        <div class="title">卡号：</div>
        <div class="value">{{data.card_num}}</div>
      </div>
      <div class="row">
        <div class="title">IC卡ID：</div>
        <div class="value">{{data.ic_card}}</div>
      </div>
      <!-- <div class="row">
        <div class="title">家长姓名：</div>
        <div class="value">{{data.name}}</div>
      </div>
      <div class="row">
        <div class="title">手机号码：</div>
        <div class="value">{{data.mobile}}</div>
      </div> -->
      <div class="row">
        <div class="title">姓名：</div>
        <div class="value">{{data.name}}</div>
      </div>
      <div class="row">
        <div class="title">余额：</div>
        <div class="value"><b class="price fprimary">{{data.balance * 0.01}}</b></div>
      </div>
      <div class="row">
        <div class="title">更换时间：</div>
        <div class="value">{{data.updated_at}}</div>
      </div>
      <div class="row">
        <div class="title">操作人：</div>
        <div class="value">{{data.operator}}</div>
      </div>
    </div>
    </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import apis from '@/business/apis'
export default {
  inject: ['eventBus'],
  data () {
    return {
      data: {},
      showModal: false
    }
  },
  computed: {
    ...mapState('school', [
      'currentSchool'
    ])
  },
  methods: {
    async showCardDetailModal (record) {
      const query = '?customerId=' + record.customer_id + '&schoolId=' + this.currentSchool._id
      const response = await this.$http.get(apis.user.mealCardInfo + query)
      if (response.body.err) return
      record.ic_card = response.body.card.ic || record.ic_card
      this.showModal = true
      this.data.card_num = record.card_num
      this.data.ic_card = record.ic_card
      this.data.name = record.name
      this.data.balance = response.body.card.balance
      this.data.operator = response.body.operator || ''
      this.data.updated_at = response.body.updated_at ? moment(response.body.updated_at).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    async clickOk () {
      this.showModal = false
    }
  },
  created () {
    this.eventBus.$on('show-carddetail-modal', this.showCardDetailModal)
  },
  beforeDestroy () {
    this.eventBus.$off('show-carddetail-modal', this.showCardDetailModal)
  }
}
</script>
